<template>
  <b-dropdown
    aria-role="list"
    position="is-bottom-left"
    class="bookmark-actions"
  >
    <button
      slot="trigger"
      class="button is-light"
    >
      <b-icon icon="ellipsis-h" />
    </button>

    <b-dropdown-item
      v-if="showOpen"
      aria-role="listitem"
      @click="showRecord(bookmark)"
    >
      open
    </b-dropdown-item>
    <b-dropdown-item
      aria-role="listitem"
      @click="reparse(bookmark.id)"
    >
      refresh
    </b-dropdown-item>
    <b-dropdown-item
      aria-role="listitem"
      @click="wayback(bookmark)"
    >
      wayback
    </b-dropdown-item>
    <b-dropdown-item separator />
    <b-dropdown-item
      aria-role="listitem"
      @click="editRecord(bookmark.id)"
    >
      edit
    </b-dropdown-item>
    <b-dropdown-item
      aria-role="listitem"
      @click="confirmDelete(bookmark.id)"
    >
      delete
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: 'BookmarkActionsMenu',
  props: ['bookmark', 'showOpen'],
  methods: {
    showRecord(bookmark) {
      this.$emit('openViaExtension', bookmark)
    },
    confirmDelete(id) {
      this.$emit('confirmDeleted', id)
    },
    deleteSelected(id) {
      this.$emit('deletedSelected', id)
    },
    editRecord(id) {
      this.$emit('editRecord', id)
    },
    reparse(id) {
      this.$emit('reparse', id)
    },
    wayback(bookmark) {
      this.$emit('wayback', bookmark)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
